import { Circle } from "native-base";

export default Circle;